<script setup lang="ts">
import { useTranslations } from '@/shared/composables/useTranslations';
import { useCartStore } from '@/shared/pinia/modules/cart';

const cartStore = useCartStore();
const { t } = useTranslations();

const imageUrl =
  document.querySelector<HTMLElement>('.js-mini-cart-mount')?.dataset
    .emptyCartImageUrl ?? '';
</script>

<template>
  <div class="mx-auto flex flex-col items-center gap-4 overflow-y-auto px-4">
    <div
      class="w-full pt-10 text-center text-2xl font-bold md:text-2xl lg:text-3xl"
    >
      {{ t('cart.your_cart_is_empty_title') }}
    </div>
    <div class="text-center text-base text-gray-500 lg:text-lg">
      {{ t('cart.your_cart_is_empty_sub_title') }}
    </div>
    <img
      :src="imageUrl"
      :alt="t('cart.your_cart_is_empty_title')"
      loading="lazy"
      width="720"
      height="320"
      class="mx-auto mt-16 w-full max-w-96 md:mb-4 md:max-w-lg"
    />
    <button
      class="btn-md btn-primary w-full max-w-sm text-center"
      @click="cartStore.miniCartOpen = false"
    >
      {{ t('cart.lets_fill_the_cart') }}
    </button>
  </div>
</template>
